import React from 'react';
import { OrderItem } from '../../constants/types';
import { OptionList } from './OptionList';

interface OrderItemListProps {
  orderItems: OrderItem[];
}
const OrderItemList = ({ orderItems }: OrderItemListProps) => {
  return (
    <div className="flex w-full flex-col items-center justify-between gap-y-2">
      {orderItems.map((orderItem, key) => (
        <div key={key} className="flex w-full justify-between p-2">
          <div className="flex flex-col gap-y-2">
            {/* 물품인 경우 */}
            {orderItem.chosen_variants.length > 0 && (
              <OptionList orderItem={orderItem} type="variant_details" />
            )}

            {/* 코스인 경우 */}
            {orderItem.enroll_options.length > 0 && (
              <OptionList orderItem={orderItem} type="option_details" />
            )}
          </div>

          {/* 물품 썸네일 */}
          <div className="max-w-[72px]">
            <img src={orderItem.product.thumbnail.access_url} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrderItemList;
